<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="6" lg="6">
        <b-card no-body class="bg-info">
          <b-card-body>
             <h4 class="mb-0">{{ getLength(groups) }}</h4>
            <p>Groups</p>
            <b-button variant="primary" @click="addGroup">Add New Group</b-button>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col sm="6" lg="6">
        <b-card no-body class="bg-info">
          <b-card-body>
            <h4 class="mb-0">Search</h4>
            <p>By Group Name, Member Organizations or Default Organization</p>
            <b-input-group>
              <b-form-input v-model="filter.nameText" @input="handleFilterChange" placeholder="Type to Search" />
              <b-input-group-addon>
                <b-btn :disabled="!filter.nameText" @click="clearFilter">Clear</b-btn>
              </b-input-group-addon>
            </b-input-group>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col sm="12">
        <div>
          <b-btn v-b-toggle.collapse1 variant="primary">Filters</b-btn>
          <b-btn
          v-on:click.prevent="resetFilters">Clear Filters</b-btn>

          <b-collapse id="collapse1" class="mt-2">
            <b-card>
              <b-row>
                <b-col sm="3">
                  <b-form-group label="Is Owning Group">
                    <b-form-select class="mb-2 mr-sm-2 mb-sm-0"
                      v-model="filter.isOwningGroup"
                      :style="{ width: '150px' }">
                      <option slot="first" :value="null">Choose...</option>
                      <option value="true">true</option>
                      <option value="false">false</option>
                    </b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-card>
          </b-collapse>
        </div>
      </b-col>
    </b-row>
    <br>

    <b-row>
      <b-col sm="12">
        <b-card>
          <h2 v-show="!finishedLoading" class="u-padding-bottom-20">Loading, please wait ...</h2>
          <pulse-loader :loading="!finishedLoading" :color="spinnerColor" :size="spinnerSize"></pulse-loader>
          <b-table
              v-show="finishedLoading"
              :filter="filter"
              :filter-function="searchFilter"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              @filtered="onFiltered" :hover="true"
              :striped="true"
              :bordered="false"
              :small="true"
              :fixed="true"
              responsive="sm"
              :items="groups"
              :fields="getTableFields()"
              :per-page="20"
              :current-page="currentPage">
               <div slot="groupName" class slot-scope="item">
              <b-link @click="goGroup(item.item.id)">
                <span class>{{item.value}}</span>
              </b-link>
            </div>
              <div slot="b_confirmed" class="" slot-scope="item">
                <span :v-if="item.value !== ''" class="">{{item.value}}</span>
              </div>
          </b-table>
          <b-pagination :total-rows="getLength(groups)" prev-text="Prev" next-text="Next" :current-page="currentPage" v-model="currentPage"></b-pagination>
        </b-card>
      </b-col>
    </b-row>
  </div>

</template>

<script>
import { mapGetters } from 'vuex'
import MainChart from '@/views/charts/MainChart'
import cTable from '@/views/tables/Table'

export default {
  name: 'GroupList',
  components: {
    MainChart,
    cTable
  },
  computed: {
    ...mapGetters({
      userCurrentContext: 'userCurrentContext',
      groups: 'getAllGroups'
    })
  },
  watch: {
    userCurrentContext: function (newValue) {
      if (newValue) {
        this.searchGroups()
      }
    }
  },
  data: function () {
    return {
      spinnerColor: '#489AAC',
      spinnerSize: '50px',
      finishedLoading: false,
      modalInfo: { title: '', content: '' },
      selected: 'Month',
      currentPage: 1,
      filter: {
        nameText: sessionStorage.getItem('groupSearchFilter') || '',
        isOwningGroup: null
      },
      showDataTable: false,

      // Fields for the Data Table
      totalRows: 0,
      supportBackup: true,
      supportNested: true,
      query: { limit: 10 },
      data: [],
      total: 0,
      Pagination: true,

      // Fields for the bootstrap table
      sortBy: 'timestamp',
      sortDesc: true,
      sortDirection: 'desc',
      tableFields: {
        groupName: {
          label: 'Group Name',
          sortable: true
        },
        isOwningGroup: {
          label: 'Is Owning Group',
          sortable: true
        },
        memberOrgTitles: {
          label: 'Member Organizations',
          sortable: true
        },
        defaultOrg: {
          label: 'Default Organization',
          sortable: true,
          formatter: function (value) {
            if (value) {
              return value.title
            }
          }
        }
      }
    }
  },
  created: function () {
    this.searchGroups()
  },
  methods: {
    searchGroups () {
      this.$store.dispatch('getAllGroups', {}).then(response => {
        this.finishedLoading = true
        this.totalRows = this.groups.length
      })
    },
    resetFilters () {
      this.filter.isOwningGroup = null
    },
    searchFilter (groupRecord) {
      let foundMatch = false
      let foundIsOwning = true
      const stringSearches = [ 'groupName', 'isOwningGroup', 'memberOrgTitles', 'defaultOrg' ]

      if (this.filter.isOwningGroup !== null) {
        foundIsOwning = this.filter.isOwningGroup === (groupRecord['isOwningGroup'] ? 'true' : 'false')
      }

      if (this.filter.nameText !== null) {
        let filter = this.filter.nameText.toLowerCase()
        _.forEach(stringSearches, element => {
          let field = groupRecord[element]
          if (_.isString(field) && field !== '') {
            field = field.toLowerCase()
            if (groupRecord[element].toLowerCase().indexOf(filter) >= 0) {
              foundMatch = true
            }
          }
        })
      } else {
        foundMatch = true
      }
      return foundMatch && foundIsOwning
    },
    getTableFields () {
      return this.tableFields
    },
    goGroup (item) {
      if (item) {
        const path = '/admin/groups/' + item
        this.$router.push({ path: path })
      }
    },
    addGroup (item) {
      this.$router.push({ path: '/admin/groups/add' })
    },
    variant (value) {
      let $variant
      if (value <= 25) {
        $variant = 'info'
      } else if (value > 25 && value <= 50) {
        $variant = 'success'
      } else if (value > 50 && value <= 75) {
        $variant = 'warning'
      } else if (value > 75 && value <= 100) {
        $variant = 'danger'
      }
      return $variant
    },
    flag (value) {
      return 'flag-icon flag-icon-' + value
    },
    getLength (items) {
      if (this.filter) {
        return this.totalRows
      }
      return items.length
    },
    onFiltered (filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    handleFilterChange (value) {
      sessionStorage.setItem('groupSearchFilter', value)
    },
    clearFilter (value) {
      this.filter.nameText = ''
      sessionStorage.setItem('groupSearchFilter', '')
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/t1/Admin/GroupList.vue